const shouldShowProgress = (exemptions: unknown[], entries: unknown[]): boolean =>
  !exemptions.length || entries.length > 0;

export default shouldShowProgress;
